import { useCopilotMessagesContext } from '@copilotkit/react-core';
import {
  ActionExecutionMessage,
  ResultMessage,
  TextMessage,
} from '@copilotkit/runtime-client-gql';
import { useEffect } from 'react';

export const useSaveRestoreMessages = (messageKey?: string) => {
  const { messages, setMessages } = useCopilotMessagesContext();

  // Save Chat Messages
  useEffect(() => {
    if (!messageKey || messages.length === 0) {
      return;
    }

    const chatMessages = JSON.stringify(messages);
    localStorage.setItem(`messages-${messageKey}`, chatMessages);
  }, [messageKey, messages]);

  // Restore Chat Messages
  useEffect(() => {
    if (!messageKey) {
      return;
    }

    const chatMessages = localStorage.getItem(`messages-${messageKey}`) || '[]';

    const chatMessagesJson = JSON.parse(chatMessages) as (
      | TextMessage
      | ActionExecutionMessage
      | ResultMessage
    )[];

    const parsedMessages = chatMessagesJson.map((message) => {
      if (message.type === 'TextMessage') {
        return new TextMessage(message as TextMessage);
      } else if (message.type === 'ActionExecutionMessage') {
        return new ActionExecutionMessage(message as ActionExecutionMessage);
      } else if (message.type === 'ResultMessage') {
        return new ResultMessage(message as ResultMessage);
      } else {
        throw new Error(`Unknown message type: ${message.type}`);
      }
    });

    setMessages(parsedMessages);

    return () => {
      setMessages([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageKey]);
};
